import React from 'react';

import BaseLightboxContainer from './BaseLightboxContainer';

const LoginLightboxContainer = () => (
  <BaseLightboxContainer
    type="login"
    title="Please sign in..."
    message="Please log in on the iOS app to receive notifications for this event."
    messagesByType= {{
      HORSE: "Please log in to add this horse to your stable",
      JOCKEY: "Please log in to add this jockey to your stable",
      TRAINER: "Please log in to add this trainer to your stable"
    }}
  />
);

export default LoginLightboxContainer;



// WEBPACK FOOTER //
// ./modules/Common/containers/Lightboxes/LoginLightboxContainer.js